<template>
  <div class="relative w-full">
    <b-form-group
      id="input-group-1"
      label-for="input-2"
      label-class="w-full mb-0"
    >
      <template #label>
        <div class="flex justify-between items-center h-6 mb-1">
          <span class="font-medium text-[#333333]">Pilih Gudang<span class="text-danger">*</span></span>
          <b-button
            variant="link"
            size="sm"
            class="!p-0 text-primary font-medium hover:underline text-sm"
            :disabled="isAddWarehouse"
            @click="onAddWarehouse"
          >
            + Tambah Gudang
          </b-button>
        </div>
      </template>
      <v-select
        id="input-2"
        v-model="formData.address_id"
        name="address_id"
        placeholder="Pilih gudang"
        :reduce="item => item.id"
        required
        label="name"
        :options="warehouseList"
        class="custom-warehouse-select"
        @input="onInput"
      >
        <template #no-options>
          <div class="flex my-1 justify-center">
            <div class="border w-fit rounded-md p-[8px]">
              <b-img
                width="30"
                height="30"
                center
                src="https://storage.googleapis.com/komerce/assets/icons/search-abu.svg"
              />
            </div>
          </div>
          <div class="text-[#333333]">
            Belum ada data gudang
          </div>
          <div class=" mb-2 text-[#828282]">
            Tambahkan gudang kamu
          </div>
        </template>
        <template #selected-option="data">
          <div>
            {{ data.name }}
          </div>
        </template>
        <template #option="data">
          <div>
            <div class="text-semibold">
              {{ data.name }}
            </div>
            <div class="">
              {{ data.detail_address }}
            </div>
          </div>
        </template>
      </v-select>
    </b-form-group>
    <div
      v-show="isAddWarehouse"
      class="absolute left-0 top-[100%] mt-1 w-full z-50 bg-white shadow-lg rounded-md border border-gray-200 overflow-hidden"
    >
      <AddWhereHouse
        @onAddWareHouse="onAddWarehouse"
        @refresh="onRefreshWarehouseList"
      />
    </div>
  </div>
</template>

<script>
import VSelect from 'vue-select'
import { mapState } from 'vuex'
import AddWhereHouse from '../AddWhereHouse.vue'

export default {
  components: {
    VSelect,
    AddWhereHouse,
  },
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isAddWarehouse: false,
    }
  },
  computed: {
    ...mapState('komchat', {
      warehouseList: state => state.warehouseList || [],
    }),
  },
  mounted() {
    this.$store.dispatch('komchat/getWarehouseList')
  },
  methods: {
    onRefreshWarehouseList() {
      this.$store.dispatch('komchat/getWarehouseList')
    },
    onAddWarehouse() {
      this.isAddWarehouse = !this.isAddWarehouse
    },
    onInput(event) {
      this.$emit('update-address', event)
      this.$emit('validate')
    },
  },
}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';

.custom-warehouse-select {
  .vs__dropdown-toggle {
    min-height: 40px !important;
    border-radius: 8px !important;
    border: 1px solid #E2E8F0 !important;
    padding: 0 0.5rem !important;
    align-items: center;
  }

  .vs__selected {
    color: #1E293B !important;
    font-size: 0.875rem !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .vs__search {
    margin: 0 !important;
    padding: 0 !important;
    font-size: 0.875rem !important;
    color: #1E293B !important;

    &::placeholder {
      color: #94A3B8 !important;
    }
  }

  &.vs--open .vs__dropdown-toggle {
    border-color: #F97316 !important;
    box-shadow: 0 0 0 1px rgba(249, 115, 22, 0.2) !important;
  }
}
</style>
